// Compact version of the daily brief score card for the property page — the
// "book direct and this is your concierge" pitch. Sits BELOW the booking
// module and is styled cream-on-hairline, not navy: next to a property title
// the navy card read as a review score for the house, and "7/10" is a rough
// first impression to give a home. The label says what the number scores.
// Renders nothing if the brief can't load; the booking flow must not depend on it.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchBrief } from '../../lib/data.js';

export default function BriefSnapshot() {
  const [brief, setBrief] = useState(null);

  useEffect(() => {
    fetchBrief('/api/get-brief').then(setBrief).catch(() => {});
  }, []);

  if (!brief?.score) return null;

  // Compact one-liner from the windowed topPicks; older briefs send a single
  // pre-joined topPick string.
  const picks = brief.score.topPicks;
  const topPick = picks
    ? [picks.morning, picks.afternoon, picks.evening].filter(Boolean).join(' · ')
    : brief.score.topPick;

  return (
    <div className="rounded-xl border border-navy-100 bg-cream-100/70 px-5 py-5">
      <p className="text-xs font-medium uppercase tracking-[0.18em] text-cream-600">
        Today's conditions in Charleston: {brief.score.value}/10
      </p>
      <p className="mt-2 font-display text-lg leading-snug text-navy-900">
        {brief.score.headline}
      </p>
      {topPick && (
        <p className="mt-2 text-sm text-navy-700">
          <span className="font-medium text-navy-900">Top picks: </span>
          {topPick}
        </p>
      )}
      <p className="mt-3 text-sm text-navy-700">
        A new brief lands every morning by 6:30 ET, all stay long.{' '}
        <Link to="/" className="text-navy-900 underline">
          Read today's full brief
        </Link>
      </p>
    </div>
  );
}
